import { useDebounceCallback } from '@react-hook/debounce';
import { FETCH_STATUSES } from 'common/constants/constants';
import { getDefaultIterations } from 'common/services/iterations.service';
import { useEffect, useMemo, useState } from 'react';
import {
  formatIterationRange,
  ITERATION_STATES
} from 'state/selectors/iterations-picker';

const useTeamIterations = teamId => {
  const [status, setStatus] = useState(FETCH_STATUSES.IDLE);
  const [iterations, setIterations] = useState([]);

  const formatIteration = iteration => {
    const range = formatIterationRange(iteration);
    const computedName = `${iteration.name} (${range})`;

    return {
      ...iteration,
      isPostRouteSetter: true,
      range: formatIterationRange(iteration),
      computedName
    };
  };

  const activeIterations = useMemo(
    () =>
      iterations.filter(
        iteration => iteration.state === ITERATION_STATES.ACTIVE
      ),
    [iterations]
  );

  const pastIterations = useMemo(
    () =>
      iterations.filter(
        iteration => iteration.state === ITERATION_STATES.CLOSE
      ),
    [iterations]
  );

  const fetchTeamIterations = useDebounceCallback(async () => {
    try {
      const resIterations = await getDefaultIterations({ team_id: teamId });
      const formattedIterations = resIterations.map(formatIteration);
      setIterations(formattedIterations);
    } catch (e) {
    } finally {
      setStatus(FETCH_STATUSES.FINISHED);
    }
  }, 200);

  useEffect(() => {
    if (teamId) {
      setStatus(FETCH_STATUSES.LOADING);
      fetchTeamIterations();
    } else {
      setIterations([]);
    }
  }, [teamId]);

  return {
    status,
    iterations,
    activeIterations,
    pastIterations
  };
};

export default useTeamIterations;
